<script setup>
const emit = defineEmits(['deleteFavorite']);

const props = defineProps({
  goodsFavId: {
    type: Number,
    required: true
  },
  goodsFavName: {
    type: String,
    required: true
  }
});

</script>

<template>
  <div class="modal com_modal2 fade" id="deleteFavoriteConfirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1">以下のお気に入りグループを削除しますか</h3>
          <p class="com_fs14 com_center1 com_mgb0">{{ props.goodsFavName }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1" @click="emit('deleteFavorite', props.goodsFavId)">はい</button>
          <button type="button" class="btn com_btn2" data-bs-dismiss="modal">いいえ</button>
        </div>
      </div>
    </div>
  </div>
</template>
